import React from "react";
import Styles from './styles.module.scss';
import { useTranslation } from "react-i18next";

const AboutS1 = () => {
    const { t } = useTranslation();

    return (
        <section className={Styles.container}>
            <div className={Styles.absLine}/>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.contentWrapTitle}`}>{t('О нас')}</div>
                <div className={`${Styles.noteWrap}`}>
                    <div className={`${Styles.noteItem}`}>{t('Мы — технологичный лаунчпад, объединяющий передовые технологии, прозрачные механизмы и продуманную токеномику. Мы создаём безопасные и прибыльные условия, где участники получают доступ к лучшим проектам, а проекты — к подготовленным и активным людям.')}</div>
                    <div className={`${Styles.noteItem}`}>{t('Наша платформа поддерживает молодых компаний структурированным запуском, аналитикой и профессиональным сообществом, а участникам даёт понятные правила, инструменты и возможности для эффективной работы в криптопространстве.')}</div>
                </div>
            </div>
        </section>
    );
};

export default AboutS1;




